import { render, staticRenderFns } from "./ModalShowPhotoInResult.vue?vue&type=template&id=5c4b5dfe&scoped=true&"
import script from "./ModalShowPhotoInResult.vue?vue&type=script&lang=js&"
export * from "./ModalShowPhotoInResult.vue?vue&type=script&lang=js&"
import style0 from "./ModalShowPhotoInResult.vue?vue&type=style&index=0&id=5c4b5dfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4b5dfe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c4b5dfe')) {
      api.createRecord('5c4b5dfe', component.options)
    } else {
      api.reload('5c4b5dfe', component.options)
    }
    module.hot.accept("./ModalShowPhotoInResult.vue?vue&type=template&id=5c4b5dfe&scoped=true&", function () {
      api.rerender('5c4b5dfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/ModalShowPhotoInResult.vue"
export default component.exports